import moment from 'moment';

export const dateFormatDDMMYYY = (date: string) => {
  return moment(date).format('DD.MM.YYYY');
};
